// Date constants for revalorization schedule
export const REVALORIZATION_DATES = {
  JANV_2026: new Date('2026-01-01'),
  MAY_2026: new Date('2026-05-28'),
  JULY_2025: new Date('2025-07-01'),
  SEPTEMBER_2026: new Date('2026-09-01'),
  JULY_2027: new Date('2027-07-01')
} as const;

// Date labels
export const DATE_LABELS = {
  CURRENT: 'Actuel',
  JANV_2026: '1er janvier 2026',
  MAY_2026: '28 mai 2026',
  JULY_2025: '1er juillet 2025',
  SEPTEMBER_2026: '1er septembre 2026',
  JULY_2027: '1er juillet 2027'
} as const;